import {
    listAccessibleFarms,
} from './api_client/farm.js';
import {
    listOrganizations,
} from './api_client/organization.js';
import { farmPath } from './farm_paths.js';

/**
 * Picks the default landing path for authenticated users.
 * Users with organizations land on `/organizations`; users with only orphan
 * farms land on the first farm detail page; users with neither land on `/home`.
 * Extracted into a separate module so both the router (app.ts) and individual
 * pages can share the same logic without creating a circular import via app.ts.
 * @returns The landing path.
 */
export async function getDefaultAuthenticatedPath (): Promise<string> {
    const organizationsResult = await listOrganizations();

    if (organizationsResult.success && organizationsResult.value.length > 0) {
        return '/organizations';
    }

    // No organisations → `listAccessibleFarms` returns only orphans owned
    // by this user (membership-derived farms require an organisation). One
    // item suffices: the server already orders by name, so the first item is
    // the landing farm.
    const farmsResult = await listAccessibleFarms({
        offset: 0,
        limit: 1,
    });

    if (farmsResult.success && farmsResult.value.items.length > 0) {
        return farmPath(null, farmsResult.value.items[0].id);
    }

    return '/home';
}
